import { defineStore } from "pinia";
import { computed, ref } from "vue";
import {useApiClient} from "@/hooks/api-hook.ts";
import {Charter} from "@/api/client/models/index.ts";
import {DateOnly} from "@microsoft/kiota-abstractions";

export const useCharterDailyDeparturesStore = defineStore("charterDailyDepartures", () => {
  const api = useApiClient();

  // State
  const dailyDepartures = ref<Charter[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  // Getters
  const dailyDeparturesCount = computed(() => dailyDepartures.value.length);
  const hasDailyDepartures = computed(() => dailyDepartures.value.length > 0);
  const isLoading = computed(() => loading.value);
  const hasError = computed(() => error.value !== null);

  // Actions
  async function fetchDailyDepartures(newDate?: Date) {
    loading.value = true;
    error.value = null;

    try {
      dailyDepartures.value = await api.charter.getDailyDepartures.get({queryParameters: {date: new DateOnly({year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate()})}});
    } catch (err) {
      error.value = err instanceof Error ? err.message : "Failed to fetch audit logs";
      console.error("Error fetching audit logs:", err);
    } finally {
      loading.value = false;
    }
  }

  function clearDailyDepartures() {
    dailyDepartures.value = [];
    error.value = null;
  }

  function clearError() {
    error.value = null;
  }

  return {
    // State
    dailyDepartures,
    loading,
    error,

    // Getters
    dailyDeparturesCount,
    hasDailyDepartures,
    isLoading,
    hasError,

    // Actions
    fetchDailyDepartures,
    clearDailyDepartures,
    clearError,
  };
});
